import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Hook to fetch forest details from API Gateway
 * 
 * Fetches data from Firestore via the API Gateway endpoints:
 *   - GET /api/trees/forest/:forestId
 *   - GET /api/trees/forest/:forestId/plots
 * 
 * @param {string} forestId - The forest ID to fetch
 * @returns {object} { forest, plots, loading, error }
 */
export const useForestDetail = (forestId) => {
  const [forest, setForest] = useState(null);
  const [plots, setPlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!forestId) {
      setLoading(false);
      return;
    }

    const fetchForestDetails = async () => {
      setLoading(true);
      setError(null);
      
      try {
        // Fetch forest details from API Gateway
        const forestResponse = await api.get(`/api/trees/forest/${forestId}`);
        setForest(forestResponse.data);

        // Fetch plots associated with this forest
        const plotsResponse = await api.get(`/api/trees/forest/${forestId}/plots`);
        setPlots(plotsResponse.data || []);
        
        setLoading(false);
      } catch (err) {
        console.error('Error fetching forest details:', err);
        setError(err.response?.data?.message || 'Failed to load forest details');
        setLoading(false);
      }
    };

    fetchForestDetails();
  }, [forestId]);

  return { forest, plots, loading, error };
};

